export interface ModelPreset {
  id: string;
  name: string;
  description: string;
  params: {
    d_model: number;
    n_heads: number;
    seq_len: number;
    d_ff: number;
  };
}

const PRESETS: ModelPreset[] = [
  {
    id: 'gpt2-small',
    name: 'GPT-2 Small',
    description: '124M parameters, the original GPT-2 base model.',
    params: { d_model: 768, n_heads: 12, seq_len: 1024, d_ff: 3072 }
  },
  {
    id: 'llama-7b',
    name: 'LLaMA 7B',
    description: 'Open foundation LLM with grouped-query-friendly head count.',
    params: { d_model: 4096, n_heads: 32, seq_len: 2048, d_ff: 11008 }
  },
  {
    id: 'gpt3-175b',
    name: 'GPT-3 175B',
    description: 'Dense transformer at very large scale.',
    params: { d_model: 12288, n_heads: 96, seq_len: 2048, d_ff: 49152 }
  },
  {
    id: 'bert-base',
    name: 'BERT-Base',
    description: 'Encoder-only model used for understanding tasks.',
    params: { d_model: 768, n_heads: 12, seq_len: 512, d_ff: 3072 }
  }
];

function buildQuery(params: ModelPreset['params']): string {
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    sp.set(key, String(value));
  }
  return sp.toString();
}

export function renderPresetView(container: HTMLElement): void {
  const wrapper = document.createElement('div');
  wrapper.className = 'preset-view';

  const header = document.createElement('header');
  header.className = 'preset-header';
  header.innerHTML = '<h1>Model Presets</h1><p>Common LLM configurations. Click a card to load it into the Transformer Block view.</p>';
  wrapper.appendChild(header);

  const grid = document.createElement('div');
  grid.className = 'preset-grid';

  for (const preset of PRESETS) {
    const card = document.createElement('a');
    card.className = 'preset-card';
    card.href = `#/component/transformer-block?${buildQuery(preset.params)}`;

    const name = document.createElement('h3');
    name.textContent = preset.name;

    const desc = document.createElement('p');
    desc.textContent = preset.description;

    const specs = document.createElement('ul');
    specs.className = 'preset-specs';
    specs.innerHTML = `
      <li>d_model: ${preset.params.d_model.toLocaleString()}</li>
      <li>n_heads: ${preset.params.n_heads}</li>
      <li>seq_len: ${preset.params.seq_len.toLocaleString()}</li>
      <li>d_ff: ${preset.params.d_ff.toLocaleString()}</li>
    `;

    card.appendChild(name);
    card.appendChild(desc);
    card.appendChild(specs);
    grid.appendChild(card);
  }

  wrapper.appendChild(grid);

  container.appendChild(wrapper);
}
